import { getAgeInYears } from '@utils/dates';

interface MinorAgeAlertProps {
  firstName: string;
  dob: string;
}

export function MinorAgeAlert({ firstName, dob }: MinorAgeAlertProps) {
  const age = getAgeInYears(dob);
  if (age === null) return null;

  const name = firstName.trim() || 'This person';

  return (
    <div className='order-check-eligibility__callout' role='status'>
      <strong>{`${name} is under 18 (age ${age})`}</strong>
      <span className='order-check-eligibility__callout-helper'>
        A parent or legal guardian will need to provide consent.
      </span>
    </div>
  );
}
